import React from 'react';
import './index.css';
import Header from './components/Header';
import CountReset from './components/CountReset';

function App() {


  return (
    <div>
      <Header />
      <CountReset />
    </div>
  );
}
export default App;
/*building done */
